import Header from "../../../../../components/header";
import {
  OrderLine,
  OrderMileageValue,
  OrderMileageTitle,
  OrderMileageWrapper,
  OrderWrapper,
  OrderProductHeader,
  OrderProductHeaderTitle,
  OrderProductItem,
  OrderProductList,
  OrderCartButton,
  OrderProductEmpty,
  OrderProductSkeleton,
} from "./styles";
import { useWalletContext } from "../../hooks/wallet-context";
import { WalletTab } from "../../hooks/use-wallet-tab";
import { useEffect, useState } from "react";
import useOrder from "./hooks";
import PubFilter from "./components/pub-filter";
import { Cafe } from "../../../../../api/types";
import { getOnlyFranchisePub } from "../../../../../api/cafe";
import { useRecoilValue } from "recoil";
import { locationState } from "../../../../../recoil/pub";
import ProductSelect from "./components/product-select";
import { enqueueSnackbar } from "notistack";
import ProductCart from "./components/product-cart";
import useGeoLocation from "../../../../../hooks/useGeoLocation";

const Order = () => {
  const { setWalletTab, selectedFranchisePub, setSelectedFranchisePub } =
    useWalletContext();
  const {
    products,
    mileage,
    loading,
    setSelectedProduct,
    selectedProduct,
    cart,
    setCart,
    openProductCart,
    setOpenProductCart,
    seat,
    table,
    isPickUp,
    memo,
    setSeat,
    setTable,
    setIsPickUp,
    setMemo,
    payPubProduct,
    setMileage,
  } = useOrder();
  const [cafes, setCafes] = useState<Cafe[]>([]);
  const [openPubFilter, setOpenPubFilter] = useState(false);
  const { latitude, longitude } = useGeoLocation();

  useEffect(() => {
    const handlePopState = () => {
      setWalletTab(WalletTab.WALLET);
    };

    // 히스토리 상태 추가
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [setWalletTab]);

  const getCafes = async () => {
    const res = await getOnlyFranchisePub(latitude, longitude);
    setCafes(res.list);
  };

  useEffect(() => {
    getCafes();
  }, [selectedFranchisePub]);

  return (
    <OrderWrapper>
      <Header
        title="음료/주류 주문하기"
        back={() => setWalletTab(WalletTab.WALLET)}
      />
      <OrderMileageWrapper>
        <OrderMileageTitle>보유 주류 마일리지</OrderMileageTitle>
        <OrderMileageValue>
          {mileage ? mileage.toLocaleString() : 0}
          <img src="/image-web/order/mileage.png" alt="마일리지 단위" />
        </OrderMileageValue>
      </OrderMileageWrapper>
      <OrderLine />
      <OrderProductHeader>
        <OrderProductHeaderTitle>메뉴</OrderProductHeaderTitle>
        <PubFilter
          open={openPubFilter}
          setOpen={setOpenPubFilter}
          filterList={cafes}
          label="메뉴"
          selectedItem={selectedFranchisePub}
          setSelectedItem={setSelectedFranchisePub}
        />
      </OrderProductHeader>
      {products.length > 0 ? (
        <OrderProductList>
          {loading
            ? Array.from({ length: 6 }).map((_, index) => (
                <OrderProductSkeleton key={index}>
                  <div className="image-skeleton" />
                  <div className="title-skeleton" />
                  <div className="price-skeleton" />
                </OrderProductSkeleton>
              ))
            : // 실제 상품 목록
              products.map((product) => (
                <OrderProductItem
                  key={product.id}
                  onClick={() => setSelectedProduct(product)}
                >
                  <img
                    src={
                      product.imageUrl ?? "/image-web/order/alcohol-default.png"
                    }
                    alt={product.name}
                  />
                  <div className="title">{product.name}</div>
                  <div className="price">
                    {product.price.toLocaleString()} M
                  </div>
                </OrderProductItem>
              ))}
        </OrderProductList>
      ) : (
        <OrderProductEmpty>
          등록되어 있는 메뉴가 없어요.
          <br />
          매장 카운터에 문의해주세요!
        </OrderProductEmpty>
      )}
      <OrderCartButton
        onClick={() => {
          if (cart.length > 0) {
            setOpenProductCart(true);
          } else {
            enqueueSnackbar("장바구니에 상품을 추가해주세요. ", {
              variant: "error",
            });
          }
        }}
      >
        장바구니
      </OrderCartButton>
      {selectedProduct && (
        <ProductSelect
          cart={cart}
          setCart={setCart}
          product={selectedProduct}
          setSelectedProduct={setSelectedProduct}
        />
      )}
      {openProductCart && (
        <ProductCart
          cart={cart}
          mileage={mileage}
          setCart={setCart}
          seat={seat}
          table={table}
          isPickUp={isPickUp}
          memo={memo}
          setSeat={setSeat}
          setTable={setTable}
          setIsPickUp={setIsPickUp}
          setMemo={setMemo}
          payPubProduct={payPubProduct}
          setOpenProductCart={setOpenProductCart}
          products={products}
          setMileage={setMileage}
        />
      )}
    </OrderWrapper>
  );
};

export default Order;
